import { render, staticRenderFns } from "./GolfParkImages.vue?vue&type=template&id=1254a19a&scoped=true"
import script from "./GolfParkImages.vue?vue&type=script&lang=js"
export * from "./GolfParkImages.vue?vue&type=script&lang=js"
import style0 from "./GolfParkImages.vue?vue&type=style&index=0&id=1254a19a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1254a19a",
  null
  
)

export default component.exports